export function endTypesMatch(a, b) {
  if (a === "plug" && b === "jack") return true;
  if (a === "jack" && b === "plug") return true;
  if (a === "symmetrical" && b === "symmetrical") return true;
  return false;
}

export function isDirectAttachConnection(fromPort, toPort) {
  if (!fromPort || !toPort) return false;
  if (!fromPort.direct_attach && !toPort.direct_attach) return false;
  if (fromPort.connector !== toPort.connector) return false;
  return endTypesMatch(fromPort.end_type, toPort.end_type);
}
